import { Controller } from '@stimulus/core';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import './vjs/style.scss';
import ja from './vjs/ja.json';
import { formatTime } from './utils';
import forceFallback from './vjs/plugins/forceFallback';
import persistPlaybackRate from './vjs/plugins/persistPlaybackRate';
import persistTextTrackState from './vjs/plugins/persistTextTrackState';
import resume from './vjs/plugins/resume';
import hotkeys from './vjs/hotkeys';
import playbackRates from './vjs/playbackRates';
export default class default_1 extends Controller {
    initialize() {
        this.onTouch = this.onTouch.bind(this);
    }
    connect() {
        this.initPlayer();
    }
    disconnect() {
        this.disposePlayer();
    }
    initPlayer() {
        if (this.hasVideoTarget) {
            this.player = videojs(this.videoTarget, {
                controls: true,
                autoplay: false,
                preload: 'metadata',
                // aspectRatio: '16:9',
                fluid: true,
                language: 'ja',
                languages: {
                    ja,
                },
                playbackRates,
                userActions: {
                    hotkeys: hotkeys,
                },
                plugins: {
                    [forceFallback]: {
                        autoplay: this.autoplay,
                    },
                    [persistPlaybackRate]: {
                        key: this.key,
                    },
                    [persistTextTrackState]: true,
                    [resume]: {
                        enabled: this.resume,
                        message: (pos) => {
                            const time = formatTime(pos);
                            return `前回 ${time} を再生していました。この位置に移動しますか?`;
                        },
                        buttons: {
                            resume: '移動する',
                            reset: 'はじめから',
                        },
                        key: this.key,
                        autoplay: this.autoplay,
                    },
                },
            });
            // picture in picture を無効にする
            this.player.controlBar.options({ pictureInPictureToggle: false });
            const checkHls = () => {
                const source = this.player.currentSource();
                if (/\.m3u8$/i.test(source.src)) {
                    this.element.classList.add('vjs-hls');
                }
                else {
                    this.element.classList.remove('vjs-hls');
                }
            };
            this.player.on('loadedmetadata', checkHls);
            this.player.one('dispose', () => {
                this.player.off('loadedmetadata', checkHls);
            });
            this.player.ready(() => {
                this.player.addClass('vjs-show-big-play-button-on-pause');
                const video = this.player.$('video');
                this.player.on(video, 'touchstart', this.onTouch);
                this.player.on(video, 'contextmenu', preventRightClick);
                this.player.focus();
            });
        }
    }
    disposePlayer() {
        if (this.player) {
            this.player.blur();
            const video = this.player.$('video');
            this.player.off(video, 'touchstart', this.onTouch);
            this.player.off(video, 'contextmenu', preventRightClick);
            this.player.dispose();
        }
    }
    onTouch() {
        if (this.player.paused()) {
            this.player.play();
        }
        else {
            this.player.pause();
        }
    }
    seek(e) {
        if (this.player) {
            const target = e.currentTarget;
            const position = parseInt(target.dataset.position);
            this.player.currentTime(position);
            this.player.play();
        }
    }
    get autoplay() {
        return this.data.has('autoplay');
    }
    get resume() {
        return this.data.has('resume');
    }
    get key() {
        if (this.data.has('key')) {
            return this.data.get('key');
        }
    }
}
default_1.targets = ['video'];
function preventRightClick(e) {
    e.preventDefault();
    return false;
}
